export function getNestedValue(obj: any, path: string): any {
  if (!path) return obj

  return path.split(".").reduce((value, key) => {
    if (value === null || value === undefined) return undefined

    // Handle plain array-index segment like "[0]"
    const indexOnlyMatch = /^\[(\d+)\]$/.exec(key)
    if (indexOnlyMatch) {
      const idx = Number(indexOnlyMatch[1])
      return Array.isArray(value) ? value[idx] : undefined
    }

    // Handle propName or propName[index]
    const match = /^([^\[\]]+)(?:\[(\d+)\])?$/.exec(key)
    if (!match) return undefined

    const prop = match[1]
    const index = match[2]

    let result = value?.[prop]
    if (index !== undefined) {
      result = Array.isArray(result) ? result[Number(index)] : undefined
    }

    return result
  }, obj)
}
